import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_51MeuHnBq44xeUkkuNdw8WadglUbnzBvB8q4wZGhlCWMnx2gcHkc7meI2WqZyIIC79ONU1eVPNrDxTlejbr1BUFGT00TCge0SEH');

const PLANS = [
  { label: '3 Months', value: '3m', price: 8.99, description: 'Standard access' },
  { label: '6 Months', value: '6m', price: 15.99, description: 'Save 11%' },
  { label: '12 Months', value: '12m', price: 27.99, description: 'Save 22%' },
];

export default function PaymentIntegration({ feature = 'premium', currency = 'GBP', onPaymentSuccess }) {
  const [selectedPlan, setSelectedPlan] = useState(PLANS[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCheckout = async () => {
    setLoading(true);
    setError('');
    try {
      // For now, we'll use a temporary solution until Lambda is deployed
      // This will be updated once we deploy the Lambda function
      const response = await fetch('https://your-lambda-url.amazonaws.com/stripe-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ feature, plan: selectedPlan.value, price: selectedPlan.price, currency }),
      });
      
      if (!response.ok) {
        throw new Error('Payment service unavailable. Please try again later.');
      }
      
      const data = await response.json();
      if (!data.sessionId) throw new Error('Failed to create payment session');
      
      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId: data.sessionId });
    } catch (err) {
      setError(err.message || 'Payment failed. Please try again.');
      console.error('Payment error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-integration">
      <h3>Choose Your Subscription</h3>
      <div className="plan-options">
        {PLANS.map(plan => (
          <label key={plan.value} className={`plan-option${selectedPlan.value === plan.value ? ' selected' : ''}`} style={{ display: 'block', marginBottom: 12, cursor: 'pointer' }}>
            <input
              type="radio"
              name="plan"
              value={plan.value}
              checked={selectedPlan.value === plan.value}
              onChange={() => setSelectedPlan(plan)}
              style={{ marginRight: 8 }}
            />
            <span style={{ fontWeight: 'bold' }}>{plan.label}</span> - £{plan.price.toFixed(2)} <span style={{ color: '#3b82f6', marginLeft: 8 }}>{plan.description}</span>
          </label>
        ))}
      </div>
      <button className="btn btn-primary" onClick={handleCheckout} disabled={loading} style={{ marginTop: 16 }}>
        {loading ? 'Processing...' : `Unlock for £${selectedPlan.price.toFixed(2)}`}
      </button>
      {error && <div className="error-message" style={{ color: 'red', marginTop: 8 }}>{error}</div>}
    </div>
  );
}

// Payment Processing Hook
export function useStripePayment() {
  const [paymentStatus, setPaymentStatus] = useState('idle');
  const [paymentError, setPaymentError] = useState('');

  const processPayment = async (amount, currency, description) => {
    try {
      setPaymentStatus('processing');
      setPaymentError('');

      // Mock payment processing - replace with actual Stripe API
      const paymentResult = await new Promise((resolve, reject) => {
        setTimeout(() => {
          if (Math.random() > 0.1) { // 90% success rate
            resolve({
              success: true,
              transactionId: `txn_${Date.now()}`,
              amount,
              currency,
              status: 'succeeded'
            });
          } else {
            reject(new Error('Payment failed'));
          }
        }, 2000);
      });

      setPaymentStatus('completed');
      return paymentResult;
    } catch (err) {
      setPaymentStatus('failed');
      setPaymentError(err.message);
      throw err;
    }
  };

  return {
    paymentStatus,
    paymentError,
    processPayment
  };
} 